export default Object.freeze({
  TerapiaABA: 658,
  TerapiaOcupacional: 128,
  TerapiaEntrenamientoAuditivo: 674,
  TerapiaVisual: 709,
  ServiceAssistant: 711,
  Interprete: 1779,
});
